import React from 'react';
import classNames from 'classnames';
import { Spacer } from '@cleartrip/bento';
import { Table } from 'components/composite';

import { ReactComponent as Chevron } from 'assets/icons/chevron.svg';

function AirportsUae({ airportInfo, tableHeader, caption }) {
	return (
		<>
			<Spacer className='pt-4 pt-0--xs' />
			<Table>
				<Table.Head className='bg-neutral-0 c-neutral-700 fs-2 br-4 mb-2 flex flex-middle d-none--xs pl-4'>
					{tableHeader.map((item) => (
						<Table.Column span={7} className='py-4  d-none--sm d-none--xs pl-0'>
							{item}
						</Table.Column>
					))}
				</Table.Head>
				
				{airportInfo.map((item) => (
					<>
						<Table.Row
							className={classNames('c-neutral-700 fs-3 px-2', {
								'c-default': !item.moreInfo,
								'c-pointer hover:elevation-3': item.moreInfo.length,
							})}
							dotlist={item.moreInfo.length && item.moreInfo}
							listStyle='none'
						>
							<Table.Column span={7} xs={24} className='pt-3 pb-3 pt-4--xs pb-0--xs flex flex-between flex-middle pb-1--xs fw-700'>
								<span>{item.name}</span>
								{item.moreInfo.length > 0 && (
								<span className='p-relative d-none d-block--xs'>
									<div className='flex'>
										<span className='chevron-text pr-1'>Details</span>
										<Chevron height={16} width={12} className='chevron c-secondary-500 pt-1' />
									</div>
								</span>
								)}
							</Table.Column>
							<Table.Column
								span={7}
								xs={24}
								className={classNames('py-3 py-1--xs fw-500 flex-middle', {
									'c-success-500': item.status.toLowerCase() === 'open',
									'c-error-500': item.status.toLowerCase() === 'closed',
								})}
							>
								{item.status}
							</Table.Column>
							<Table.Column span={8} xs={24} className='pt-3 pb-3 flex-middle pt-1--xs pb-3--xs'>
								<span className='d-none d-block--xs mr-1'>Transport:</span>
								{item.transport}
							</Table.Column>
							{item.moreInfo.length > 0 && (
								<Table.Column span={2} className='d-none--xs pr-4 flex-end'>
									<Chevron height={16} width={12} className='chevron c-secondary-500' />
								</Table.Column>
							)}
						</Table.Row>
					</>
				))}
			</Table>
		</>
	);
}

export default AirportsUae;
